'use strict';

angular.module('study.documents', [
    'route',
    'sharecrf-files',
    'study.i18n',
]);
